module.exports = __webpack_public_path__ + "fa-solid-900.svg?49279363201ed19a840796e05a74a91b";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.svg
// module id = 222
// module chunks = 0